import { useMemo } from "react";

import { getResourceIRI } from "@sol/sdk";
import { useFrameworkListQuery } from "@sol/sdk/frameworks";
import { OrderingDirection } from "@sol/sdk/utils/api";
import { Select, type SelectProps } from "@sol/uikit/data-entry/Select/Select";

import { FrameworkIdentity, toFrameworkLabel } from "@/entities/framework";
type Props = {} & SelectProps;

const filterOption = (input: string, option?: { label?: string }) =>
    String(option?.label ?? "")
        .toLowerCase()
        .includes(input.toLowerCase());

export function UnrestrictedFrameworkSelect({ ...rest }: Props) {
    const { data, isLoading } = useFrameworkListQuery(
        {
            filters: { restricted: false },
            order: { by: "title", direction: OrderingDirection.ASC },
        },
        { useErrorBoundary: true, suspense: false },
    );

    const options = useMemo(
        () =>
            data?.["hydra:member"].map(framework => {
                return {
                    label: toFrameworkLabel(framework),
                    value: getResourceIRI(framework),
                    framework,
                };
            }) ?? [],
        [data],
    );

    return (
        <Select
            {...rest}
            options={options}
            loading={isLoading}
            filterOption={filterOption}
            optionRender={({ data: option }) => <FrameworkIdentity {...option.framework} />}
            showSearch
            virtual={false}
        />
    );
}
